import type { DriveStep } from "driver.js";

export const SITE_PLAN_TOUR_STEPS: DriveStep[] = [
  {
    element: '[data-tour="site-plan-date"]',
    popover: {
      title: "Stichtag",
      description:
        "Wählen Sie den Tag, für den die Belegung angezeigt wird. Mit „Heute“ springen Sie zurück zum aktuellen Datum.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="site-plan-legend"]',
    popover: {
      title: "Legende",
      description:
        "Farben zeigen den Belegungsstatus: frei, reserviert, eingecheckt, gesperrt oder Dauercamper. So erkennen Sie die Lage auf einen Blick.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="site-plan-canvas"]',
    popover: {
      title: "Interaktiver Plan",
      description:
        "Klicken Sie auf einen Stellplatz, um Belegungsdetails und freie Zeiträume zu sehen. Von dort aus können Sie Buchungen anlegen oder Aufenthalte öffnen.",
      side: "top",
      align: "center",
    },
  },
];
